module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand6-53f2a6c16a4c7c51dc4f597007baeecb.jpg";